import * as numeral from 'numeral';
import * as _ from 'underscore';

import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DeviceTableComponent } from '../device-table/device-table.component';
import { Devicesr6Component } from '../devicesr6/devicesr6.component';

@Component({
	selector: 'app-conversionr6',
	styleUrls: ['../../../../../assets/styles/styles-v6.css'],
	templateUrl: './conversionr6.component.html'
})
export class Conversionr6Component extends Devicesr6Component implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() downloadconfig: string;
	@Input() legend: any;
	@Input() metricsarray: any;
	@Input() sectionclass: any;
	@Input() downloadcsvcolumns: any;
	@Input() multichartconfigurations: any;
	@ViewChild('chartElement') chartElement: ElementRef;

	public sectiontitle: string;
	public key: string;
	public colors: string;
	public groupby: string;
	public showLoad = true;
	public hasData = true;
	public donutColors: string[] = [];
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public downloadConfiguration: DownloadConfig;
	public legendData: any;
	public chartDataObj = [];
	public donutArray = [];
	public currentLegend: any;
	public currentChartData: any;
	public totalsArray = [];
	public donutOptions = {};
	public metricsArray = [];
	public downloadCSVColumns: any;
	public isConversions = false;
	public metricObject;
	public totalCoversions;
	public totalAllConversions;
	public conversionRate;
	public totalClicks;
	public selectedMetrics: any;
	public selectedLegend: any;
	public responseData: any;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrowSize: 'small',
		distance: 0,
		offset: 0,
		arrow: true,
		size: 'small',
		duration: 750,
		scale: 'small',
		dynamicTitle: true,
		theme: 'r5-sem-coversions'
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.legend = JSON.parse(decodeURI(this.legend));
		this.metricsArray = JSON.parse(decodeURI(this.metricsarray));
		if (this.metricsArray) {
			this.metricsArray = _.filter(this.metricsArray, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.multichartconfigurations = JSON.parse(decodeURI(this.multichartconfigurations));
		this.requestData();
	}
	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.legendData = _.pluck(response.data, 'device');
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
				this.metricObject = [];
			}
		});
	}

	processResponseData(responseData: any): void {
		if (responseData) {
			this.donutArray = [];
			if (responseData.length <= 5) {
				this.responseData = responseData;
			} else {
				let tempAllConversions = 0;
				let tempConversionaction = '';
				let tempCoversions = 0;
				let tempclicks = 0;
				for (let i = 4; i < responseData.length; i++) {
					tempAllConversions += Number(responseData[i]['all_conversions']);
					tempCoversions += Number(responseData[i]['conversions']);
					tempclicks = Number(responseData[i]['clicks']);
				}
				let tempDataArray = {
					all_conversions: tempAllConversions.toString(),
					conversion_action: 'Additional',
					conversions: tempCoversions.toString(),
					clicks: tempclicks.toString(),
					tooltip: 'All other conversion actions'
				};
				let updatedRespData = responseData.splice(0, 4);
				updatedRespData.splice(4, 0, tempDataArray);
				this.responseData = updatedRespData;
			}


			this.responseData = _.map(this.responseData, (item) => {
				return {
					conversion_action: item['conversion_action'],
					conversions: item['conversions'],
					clicks: item['clicks'],
					tooltip: item['tooltip'],
					all_conversions: item['all_conversions']
				};
			});
			const currentMetricTotal = this.responseData.reduce((s, f) => {
				return s + Number(f['conversions']);
			}, 0);
			const chartData: any[] = [];
			const tableData: any[] = [];
			this.hasData = this.responseData.length > 0;
			for (let i = 0; i < this.responseData.length; i++) {
				const chartObj: any = {};
				chartObj.name = this.responseData[i].device;
				chartObj.color = this.colorUtilityService.getHEXByColorType(this.colorPalette, this.donutColors[i], 1);
				chartObj.y = this.responseData[i][this.groupby] * 1;
				chartData.push(chartObj);

				let conversions: BigInteger;
				let conversion_action: any;

				this.columns = [
					{
						cellClass: 'display-conversion_action',
						comparator: this.conversionActionComparator.bind(this),
						headerClass: 'display-impressionsHeader',
						name: 'conversion action name',
						prop: 'conversion_action',
						resizeable: false
					},
					{
						cellClass: 'display-conversions',
						comparator: this.conversionComparator.bind(this),
						headerClass: 'display-clicksHeader',
						name: 'Conversions',
						prop: 'conversions',
						resizeable: false
					}
				];

				const obj = {
					conversions: numeral(this.responseData[i].conversions).format('0,0'),
					conversion_action: this.responseData[i].conversion_action
				};

				tableData.push(obj);
			}
			this.tableData = tableData.filter((obj) => {
				return obj['conversions'] != 0 || obj['all_conversions'] != 0;
			});
			_.each(this.responseData, (item) => {
				const frmt =
					numeral((Number(item['conversions']) / currentMetricTotal) * 100).format('0, 0.00') === '100.00'
						? '0'
						: '0,0.00';
				const percentage = numeral((Number(item['conversions']) / currentMetricTotal) * 100).format(frmt);
				const donutTotal = currentMetricTotal - Number(item['conversions']);

				const obj = [
					{
						percent: percentage,
						conversions: Number(item['conversions']),
						donutTotal: donutTotal,
						title: item['conversion_action'],
						clicks: item['clicks'],
						tooltip: item['tooltip']
					}
				];

			this.donutArray.push(obj);
			});

			this.totalCoversions = currentMetricTotal.toLocaleString();
			this.totalAllConversions = this.responseData
				.reduce((s, f) => {
					return s + Number(f['all_conversions']);
				}, 0)
			.toLocaleString();
			this.totalClicks = this.donutArray[0][0]['clicks'].toLocaleString();
			const frmt_conversionRate =
			numeral((this.totalCoversions / numeral(this.donutArray[0][0]['clicks'])._value) * 100).format('0, 0.00') ===
			'100.00'
				? '0'
				: '0,0.00';
			this.conversionRate = numeral((currentMetricTotal / numeral(this.donutArray[0][0]['clicks'])._value) * 100).format(
				frmt_conversionRate
			);
			this.donutArray = this.donutArray.filter((obj) => {
				return obj[0]['conversions'] != 0;
			});
			this.metricObject = [
				{
					name: 'Conversions',
					value: this.totalCoversions,
					tooltip:
						'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
				},
				{
					name: 'Conversion Rate',
					value: this.conversionRate + '%',
					tooltip: 'The average number of conversions per ad interaction, as a percentage.'
				},
				{
					name: 'All Conversions',
					value: this.totalAllConversions,
					tooltip:
						'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
				}
			];
		}
	}

	conversionComparator(a: any, b: any, c: any, d: any): number {
		if (c.conversions < d.conversions) {
			return 1;
		}
		if (c.conversions > d.conversions) {
			return -1;
		}
	}

	conversionActionComparator(a: any, b: any, c: any, d: any): number {
		if (c.conversion_action < d.conversion_action) {
			return 1;
		}
		if (c.conversion_action > d.conversion_action) {
			return -1;
		}
	}
}
